import { InjectionToken } from '@angular/core';

import { DocumentUploadService } from '@shared/components/upload';

export const DOCUMENT_SERVICE: InjectionToken<DocumentUploadService> =
  new InjectionToken<DocumentUploadService>('Document Processing Service');
